// import type { FC, ReactNode } from "react";
//
// import clsx from "clsx";
//
// import HornIcon from "assets/icons/illustrations/button-horns.svg?react";
//
// import styles from "./styles.module.scss";
//
// import type { BaseButtonProps } from "../index";
//
// interface HornButtonProps extends BaseButtonProps {
// 	collapsed?: boolean;
// }
//
// const HornButton: FC<HornButtonProps> = ({ icon, children, collapsed, ...rest }) => {
// 	return (
// 		<button className={clsx(styles.btn, collapsed && styles.btnFloat)} {...rest}>
// 			<div
// 				className={clsx(
// 					"absolute bottom-full left-0 right-0 w-full flex justify-center -z-[1] -mb-2.5 pointer-events-none",
// 					collapsed && "opacity-0"
// 				)}
// 			>
// 				<HornIcon className="w-[62px] h-[36px]" />
// 			</div>
// 			<div className={clsx(styles.btnShape, collapsed && "opacity-0")}></div>
// 			<div className={clsx(styles.btnBorders, collapsed && "opacity-0")}></div>
// 			<div className={clsx(styles.btnContent, collapsed && styles.btnContentFloat)}>
// 				{icon && (
// 					<div className={clsx(styles.btnIconWrapper, collapsed && styles.btnIconWrapperFloat)}>
// 						<div className={styles.btnIconContent}>{icon}</div>
// 					</div>
// 				)}
// 				{children}
// 			</div>
// 		</button>
// 	);
// };
//
// export default HornButton;

import type { FC } from "react";
import React from "react";

import clsx from "clsx";

import CypherIcon from "assets/icons/illustrations/button-cypher.svg?react";

import { Btn } from "./style";

import type { BaseButtonProps } from "../index";

interface MonogramButtonProps extends Omit<BaseButtonProps, "type"> {
	type: "submit" | "button";
}

const MonogramButton: FC<MonogramButtonProps> = ({
	children,
	className = "",
	loading,
	disabled,
	startIcon,
	endIcon,
	type,
	...rest
}) => {
	return (
		<Btn className={clsx(className)} disabled={loading || disabled} type={type} {...rest}>
			<div className={clsx("absolute bottom-full left-0 right-0 w-full flex justify-center pointer-events-none")}>
				<CypherIcon className="w-[56px] h-[43px] absolute -bottom-[27px] -left-[13px]" />
				<CypherIcon className="w-[56px] h-[43px] absolute -bottom-[27px] -right-[13px] [transform:rotateY(180deg)]" />
			</div>
			<div className="button">
				<div className={clsx("btn-content")}>
					<div className={clsx("btn-selector")}>
						{!!startIcon && <div className="shrink-0">{startIcon}</div>}
						{typeof children === "string" ? <p className={clsx("text")}>{children}</p> : children}
						{!!endIcon && <div className="shrink-0">{endIcon}</div>}
					</div>
				</div>
			</div>
		</Btn>
	);
};

export default MonogramButton;
